module.exports = __webpack_public_path__ + "img/コンピュータのしくみII_1_3_4.6869e6ac.jpeg";